import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserHistory from 'screens/userHistory';
import InlineStatsPanel from '.';
import { useFetchAssetActivityLog } from 'actions/assets';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AssetActivityLog(_ref) {
  var _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    assetId = _ref.assetId,
    parentId = _ref.parentId,
    title = _ref.title,
    name = _ref.name;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasModal = _useState2[0],
    setHasModal = _useState2[1];
  var _useFetchAssetActivit = useFetchAssetActivityLog({
      assetId: assetId,
      parentId: parentId
    }),
    data = _useFetchAssetActivit.data,
    isLoading = _useFetchAssetActivit.isLoading,
    isError = _useFetchAssetActivit.isError;
  if (!data) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InlineStatsPanel, {
      isPanelLayout: isPanelLayout,
      title: title,
      data: data,
      onClick: function onClick() {
        return setHasModal(true);
      },
      isLoading: isLoading,
      isError: isError
    }), hasModal && /*#__PURE__*/_jsx(UserHistory, {
      title: t('analytics_activity_log'),
      subtitle: name,
      moreLink: undefined,
      data: data,
      cols: [t('property_user_name'), t('property_action'), t('property_date_device')],
      onClose: function onClose() {
        return setHasModal(false);
      }
    })]
  });
}
export default AssetActivityLog;